import { infoColor, infoBoxShadow, whiteColor } from '../global';

const detailCompanyOrganizerStyle = (theme) => ({
    wrapper: {
        backgroundColor: whiteColor,
    },
    marginAuto: {
        margin: 'Auto',
    },
    marginBt5vh: {
        marginBottom: '5vh',
    },
    marginBt2vh: {
        marginBottom: '2vh',
    },
    paddingRight3vW: {
        paddingRight: '3vW',
    },
    paddingLefe3vW: {
        paddingLeft: '3vW',
    },
    marginTop20: {
        marginTop: 20,
    },
    paddingTop5vh: {
        paddingTop: '5vh',
    },
    textCenter: {
        textAlign: 'center',
    },
    textRight: {
        textAlign: 'right',
    },
    textLeft: {
        textAlign: 'left',
    },
    displayTextInline: {
        display: 'inline',
    },
    container: {
        marginTop: '7vh',
        marginBottom: '5vh',
        textAlign: 'center',
    },
    image: {
        zIndex: 10,
    },
    tooltipStyle: {
        marginTop: -30,
        marginLeft: -30,
    },
    formInputInformation: {
        border: '1px solid',
        borderColor: infoColor,
        borderRadius: '8px',
        ...infoBoxShadow,
        paddingLeft: '20px',
        paddingRight: '20px',
        maxWidth: '1000px',
        marginLeft: 'auto',
        marginRight: 'auto',
        zIndex: 20,
        background: whiteColor,
        paddingTop: '5vh',
    },
    background: {
        width: '100%',
        minHeight: '700px',
        [theme.breakpoints.down('sm')]: {
            minHeight: '500px',
        },
        overflow: 'hidden',
        position: 'relative',
        zIndex: '1',
        backgroundColor: whiteColor,
        display: 'flex',
        borderRadius: '8px',
        [theme.breakpoints.up('md')]: {
            backgroundImage: 'url("/resources/mask_group.png")',
            backgroundPosition: 'left',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
        },
    },
    spacing: {
        padding: '15px 0',
    },
    note: {
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    number: {
        color: whiteColor,
        background: 'orange',
        borderRadius: '50%',
        width: '25px',
        height: '25px',
        minWidth: '25px',
        textAlign: 'center',
        fontWeight: 700,
        padding: 2,
    },
    noteContent: {
        paddingLeft: theme.spacing(1.25),
        paddingRight: 0,
    },
    eventInfo: {
        display: 'flex',
        alignItems: 'center',
        paddingTop: '12px',
        paddingBottom: '12px',
        [theme.breakpoints.up('md')]: {
            paddingTop: '24px',
            paddingBottom: '24px',
        },
    },
    items: {
        margin: '7px 0 7px 0',
    },
    buttonBig: {
        fontSize: '28px !important',
        minWidth: '200px !important',
        padding: '10px !important',
        margin: '30px !important',
        [theme.breakpoints.down('md')]: {
            fontSize: '24px !important',
            minWidth: '150px !important',
            margin: '10px  !important',
        },
    },
    maxHeight: {
        width: '650px',
        '& td,th': {
            padding: '0px 16px',
        },
    },
});

export default detailCompanyOrganizerStyle;
